export default __webpack_public_path__ + "static/media/fresh-delivery.a3fdcd67.jpeg";